'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildUrlContextUpdateMessage = buildUrlContextUpdateMessage;

var _ContextUpdateMessage = require('conversations-schema/context-update/records/ContextUpdateMessage');

var _ContextUpdateMessage2 = _interopRequireDefault(_ContextUpdateMessage);

var _messageTypes = require('conversations-schema/pubnub-message/constants/messageTypes');

var _contextTypes = require('conversations-schema/context-update/constants/contextTypes');

var _generateUuid = require('conversations-schema/common-message-format/generateUuid');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @param {string} url The parent page's current url
 * @returns {ContextUpdateMessage}
 */
function buildUrlContextUpdateMessage(url) {
  var _ENTRY_URL;

  return new _ContextUpdateMessage2.default({
    contexts: _defineProperty({}, _contextTypes.ENTRY_URL, (_ENTRY_URL = {}, _defineProperty(_ENTRY_URL, _messageTypes.MESSAGE_TYPE_ID, _contextTypes.ENTRY_URL), _defineProperty(_ENTRY_URL, 'url', url), _ENTRY_URL)),
    id: (0, _generateUuid.generateUuid)(),
    timestamp: Date.now()
  });
}